import React from "react";
import { Modal } from "react-bootstrap";

import stylecss from "./styles/ThemeModal.module.scss"
import "./modal.css";

const ThemeModal = ({
    children,
    className,
    title,
    size,
    isOpen,
    setIsOpen,
}) => {
    return (
        <Modal
            className={`${stylecss.thememodal} ${className}`}
            show={isOpen}
            onHide={() => setIsOpen(false)}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <header className={`${stylecss.header} d-flex align-items-center justify-content-between`}>
                {title &&
                    <div className={`${stylecss.headingmodal}`}>
                        <h4 className={`${stylecss.heading} mb-0`}>{title}</h4>
                    </div>
                }
            </header>

            <Modal.Body>{children}</Modal.Body>
        </Modal>
    );
};

export default ThemeModal;